// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: assignments_v2.proto

/* eslint-disable */
import type { TicketSearchFilterRequest } from "./filters";
import type { Empty } from "./google/protobuf/empty";
import type { UserGroup } from "./user-groups";
import type { Bot } from "./users";

export const protobufPackage = "proto";

export interface AssignmentV2 {
}

export interface AssignmentV2_Settings {
  cycleLength: AssignmentV2_Settings_CYCLE;
  timeZone: string;
  startDate: string | undefined;
  endDate: string | undefined;
  goal: AssignmentV2_Settings_Goal | undefined;
  cycleConfig: AssignmentV2_Settings_CycleConfig | undefined;
  revieweeType?: AssignmentV2_Settings_RevieweeType | undefined;
  revieweeClass?: AssignmentV2_Settings_RevieweeClass | undefined;
  type?: AssignmentV2_Settings_AssignmentType | undefined;
}

export enum AssignmentV2_Settings_CYCLE {
  UNDEFINED = "UNDEFINED",
  NOT_RECURRING = "NOT_RECURRING",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  BI_WEEKLY = "BI_WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum AssignmentV2_Settings_RevieweeType {
  WORKSPACE_DEFAULT = "WORKSPACE_DEFAULT",
  ASSIGNEE = "ASSIGNEE",
  PARTICIPANT = "PARTICIPANT",
  MOST_ACTIVE_AGENT = "MOST_ACTIVE_AGENT",
}

export enum AssignmentV2_Settings_RevieweeClass {
  USER = "USER",
  BOT = "BOT",
}

export enum AssignmentV2_Settings_AssignmentType {
  AGENT_QA = "AGENT_QA",
  REVIEWER_QA = "REVIEWER_QA",
}

export interface AssignmentV2_Settings_Goal {
  type: AssignmentV2_Settings_Goal_TYPE;
  config: AssignmentV2_Settings_Goal_Config | undefined;
  periodicUpdateEnabled: boolean;
}

export enum AssignmentV2_Settings_Goal_TYPE {
  UNDEFINED = "UNDEFINED",
  CONVERSATION = "CONVERSATION",
  REVIEWER = "REVIEWER",
  REVIEWEE = "REVIEWEE",
}

export interface AssignmentV2_Settings_Goal_Config {
  revieweeMinimum: number | undefined;
  unit: AssignmentV2_Settings_Goal_Config_UNIT;
  value: number;
  assigned: boolean;
  allowSelfAssignment: boolean;
  allowConversationReplacement: boolean;
}

export enum AssignmentV2_Settings_Goal_Config_UNIT {
  UNDEFINED = "UNDEFINED",
  PERCENTAGE = "PERCENTAGE",
  NUMBER = "NUMBER",
}

export interface AssignmentV2_Settings_CycleConfig {
  dayOfWeek?: AssignmentV2_Settings_CycleConfig_DAY | undefined;
  weekOfMonth?: AssignmentV2_Settings_CycleConfig_WeekOfMonth | undefined;
  dayOfMonth?: number | undefined;
  skippedDays: AssignmentV2_Settings_CycleConfig_DAY[];
}

export enum AssignmentV2_Settings_CycleConfig_DAY {
  UNDEFINED = "UNDEFINED",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export interface AssignmentV2_Settings_CycleConfig_WeekOfMonth {
  week: AssignmentV2_Settings_CycleConfig_WeekOfMonth_WEEK;
}

export enum AssignmentV2_Settings_CycleConfig_WeekOfMonth_WEEK {
  UNDEFINED = "UNDEFINED",
  FIRST = "FIRST",
  SECOND = "SECOND",
  THIRD = "THIRD",
  FOURTH = "FOURTH",
  LAST = "LAST",
}

export interface AssignmentV2_UserAvatar {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | undefined;
  isRemoved: boolean;
  avatar: string | undefined;
}

export interface AssignmentV2_UserAvatars {
  users: AssignmentV2_UserAvatar[];
  total: number;
}

export interface AssignmentV2_Assignment {
  id: string;
  name: string;
  settings: AssignmentV2_Settings | undefined;
  filter: TicketSearchFilterRequest | undefined;
  status: AssignmentV2_Assignment_Status;
  participants: AssignmentV2_Assignment_Participants | undefined;
  created: string | undefined;
  createdBy: AssignmentV2_UserAvatar | undefined;
  updated: string | undefined;
  nextCycleStart: string | undefined;
  hasPendingChanges: boolean;
}

export enum AssignmentV2_Assignment_Status {
  UNDEFINED = "UNDEFINED",
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
  RESET = "RESET",
}

export interface AssignmentV2_Assignment_Participants {
  reviewers: AssignmentV2_UserAvatar[];
  reviewees: AssignmentV2_UserAvatar[];
  excludeReviewees: AssignmentV2_UserAvatar[];
  excludeReviewers: AssignmentV2_UserAvatar[];
  reviewerGroups: UserGroup[];
  revieweeGroups: UserGroup[];
  excludeRevieweeGroups: UserGroup[];
  excludeReviewerGroups: UserGroup[];
  botReviewees: Bot[];
  excludeBotReviewees: Bot[];
}

export interface AssignmentV2_GetAssignmentsRequest {
  sort?: string | undefined;
  limit?: string | undefined;
  offset?: string | undefined;
}

export interface AssignmentV2_GetAssignmentsResponse {
  assignments: AssignmentV2_Assignment[];
  total: number;
  sort: string;
  limit: string;
  offset: string;
}

export interface AssignmentV2_Participants {
  reviewers: string[];
  reviewees: string[];
  excludeReviewees: string[];
  excludeReviewers: string[];
  reviewerGroups: string[];
  revieweeGroups: string[];
  excludeRevieweeGroups: string[];
  excludeReviewerGroups: string[];
  botReviewees: string[];
  excludeBotReviewees: string[];
}

export interface AssignmentV2_CreateAssignmentRequest {
  name: string;
  settings: AssignmentV2_Settings | undefined;
  filter: TicketSearchFilterRequest | undefined;
  participants: AssignmentV2_Participants | undefined;
  status: AssignmentV2_Assignment_Status;
}

export interface AssignmentV2_UpdateAssignmentRequest {
  assignmentId: string;
  name: string;
  settings: AssignmentV2_Settings | undefined;
  filter: TicketSearchFilterRequest | undefined;
  participants: AssignmentV2_Participants | undefined;
  status: AssignmentV2_Assignment_Status;
}

export interface AssignmentV2_AssignmentIDRequest {
  assignmentId: string;
}

export interface AssignmentV2_GetUserAssignmentsRequest {
  type?: AssignmentV2_Settings_AssignmentType | undefined;
}

export interface AssignmentV2_GetUserAssignmentsResponse {
  assignments: AssignmentV2_UserAssignment[];
}

export interface AssignmentV2_UserAssignment {
  id: string;
  name: string;
  goal: number;
  personalGoal?: number | undefined;
  reviewCount: number;
  personalReviewCount: number;
  cycleEnd: string | undefined;
  settings: AssignmentV2_Settings | undefined;
  isReviewer: boolean;
}

export interface AssignmentV2_GetUserAssignmentConversationsRequest {
  assignmentId: string;
  sort: string;
  seed?: string | undefined;
  limit: string;
  offset: string;
  revieweeIds: string[];
  reviewed?: boolean | undefined;
  hasDraft?: boolean | undefined;
  isRemovedFromAssignment?: boolean | undefined;
  reviewerIds: string[];
  excludedRevieweeIds: string[];
  excludedReviewerIds: string[];
  botIds: string[];
  excludedBotIds: string[];
}

export interface AssignmentV2_GetUserAssignmentConversationsResponse {
  conversations: AssignmentV2_GetUserAssignmentConversationsResponse_TicketListItem[];
  total: number;
  sort: string;
  seed?: string | undefined;
  limit: string;
  offset: string;
}

export enum AssignmentV2_GetUserAssignmentConversationsResponse_ConversationStatus {
  TODO = "TODO",
  DRAFT = "DRAFT",
  DONE = "DONE",
  REMOVED = "REMOVED",
}

export interface AssignmentV2_GetUserAssignmentConversationsResponse_TicketListItem {
  paymentTokenId: string;
  subject: string | undefined;
  sourceType: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  youReviewed: boolean;
  youViewed: boolean;
  highlighted: boolean;
  url: string | undefined;
  assigneeId: string | undefined;
  assigneeName: string | undefined;
  assigneePictureUrl: string | undefined;
  channel: string | undefined;
  status: string | undefined;
  type: string | undefined;
  externalId: string;
  klausSentiment: string | undefined;
  isComplex: boolean | undefined;
  assignedReviewer: AssignmentV2_UserAvatar | undefined;
  assignedReviewees: AssignmentV2_UserAvatar[];
  assignedBotReviewees: Bot[];
  ticketStatus?: AssignmentV2_GetUserAssignmentConversationsResponse_Status | undefined;
}

export interface AssignmentV2_GetUserAssignmentConversationsResponse_Status {
  status: AssignmentV2_GetUserAssignmentConversationsResponse_ConversationStatus;
  user: AssignmentV2_UserAvatar | undefined;
  removalReason?: string | undefined;
  draftAssignee?: AssignmentV2_UserAvatar | undefined;
}

export interface AssignmentV2_GetAssignmentInfoRequest {
  assignmentId: string;
}

export interface AssignmentV2_AssignmentCycle {
  id: string;
  assignmentId: string;
  start: string | undefined;
  end: string | undefined;
  settings: AssignmentV2_Settings | undefined;
  filter: TicketSearchFilterRequest | undefined;
  participants: AssignmentV2_Assignment_Participants | undefined;
  reviewers: string[];
  reviewees: string[];
  botReviewees: string[];
}

export interface AssignmentV2_GetAssignmentInfoResponse {
  cycle: AssignmentV2_AssignmentCycle | undefined;
  goal: number;
  reviewCount: number;
  reviewers: AssignmentV2_GetAssignmentInfoResponse_UserInfo[];
  reviewersWithTasks: string[];
  revieweesWithTasks: string[];
  botsWithTasks: string[];
}

export interface AssignmentV2_GetAssignmentInfoResponse_UserInfo {
  user: AssignmentV2_UserAvatar | undefined;
  goal?: number | undefined;
  reviewCount?: number | undefined;
}

export interface AssignmentV2_GetAssignmentReviewerGoalRequest {
  assignmentId: string;
  reviewerId: string;
}

export interface AssignmentV2_GetAssignmentReviewerGoalResponse {
  goal?: number | undefined;
  reviewCount: number;
}

export interface AssignmentV2_DeleteAssignmentConversationRequest {
  assignmentId: string;
  connectionId: string;
  externalId: string;
  reason: string;
}

export interface AssignmentV2_ReplaceAssignmentConversationRequest {
  assignmentId: string;
  connectionId: string;
  externalId: string;
  reason: string;
}

export interface AssignmentV2_ReplaceAssignmentConversationResponse {
  connectionId?: string | undefined;
  externalId?: string | undefined;
}

export interface AssignmentV2_ReassignConversationsRequest {
  assignmentId: string;
  fromReviewerId: string;
  toReviewerIds: string[];
}

export interface AssignmentV2_ReassignConversationRequest {
  assignmentId: string;
  connectionId: string;
  conversationId: string;
  toReviewerId: string;
}

export interface AssignmentV2_SearchAssignmentUserRequest {
  assignmentId: string;
  name: string;
  limit: number;
}

export interface AssignmentV2_LinkReviewRequest {
  assignmentId: string;
  reviewId: string;
}

export interface AssignmentReview {
}

export interface AssignmentReview_ValidateAssignmentReviewRequest {
  accountId: string;
  workspaceId: string;
  assignmentId: string;
  connectionId: string;
  conversationExternalId: string;
}

export interface AssignmentReview_CreateAssignmentReviewRequest {
  accountId: string;
  workspaceId: string;
  assignmentId: string;
  connectionId: string;
  conversationExternalId: string;
  reviewId: string;
}

export interface AssignmentReview_GetAssignmentReviewsRequest {
  accountId: string;
  workspaceId: string;
  connectionId: string;
  conversationExternalId: string;
}

export interface AssignmentReview_GetAssignmentReviewsResponse {
  reviews: AssignmentReview_GetAssignmentReviewsResponse_Review[];
}

export interface AssignmentReview_GetAssignmentReviewsResponse_Review {
  id: string;
  assignmentId: string;
  assignmentName: string;
  assignmentCycleIds: string[];
}

export interface LookerFilterValue {
  filter: LookerFilterValue_LookerFilter | undefined;
}

export interface LookerFilterValue_LookerFilter {
  name: string;
  value: string;
  assignmentId: string;
}

export interface AssignmentsV2 {
  CreateAssignment(request: AssignmentV2_CreateAssignmentRequest): Promise<AssignmentV2_Assignment>;
  UpdateAssignment(request: AssignmentV2_UpdateAssignmentRequest): Promise<AssignmentV2_Assignment>;
  DeleteAssignment(request: AssignmentV2_AssignmentIDRequest): Promise<Empty>;
  GetAssignment(request: AssignmentV2_AssignmentIDRequest): Promise<AssignmentV2_Assignment>;
  GetAssignments(request: AssignmentV2_GetAssignmentsRequest): Promise<AssignmentV2_GetAssignmentsResponse>;
  DuplicateAssignment(request: AssignmentV2_AssignmentIDRequest): Promise<AssignmentV2_Assignment>;
  ToggleAssignmentStatus(request: AssignmentV2_AssignmentIDRequest): Promise<AssignmentV2_Assignment>;
  GetUserAssignments(request: AssignmentV2_GetUserAssignmentsRequest): Promise<AssignmentV2_GetUserAssignmentsResponse>;
  GetUserAssignmentConversations(
    request: AssignmentV2_GetUserAssignmentConversationsRequest,
  ): Promise<AssignmentV2_GetUserAssignmentConversationsResponse>;
  GetAssignmentInfo(request: AssignmentV2_GetAssignmentInfoRequest): Promise<AssignmentV2_GetAssignmentInfoResponse>;
  GetAssignmentReviewerGoal(
    request: AssignmentV2_GetAssignmentReviewerGoalRequest,
  ): Promise<AssignmentV2_GetAssignmentReviewerGoalResponse>;
  DeleteAssignmentConversation(request: AssignmentV2_DeleteAssignmentConversationRequest): Promise<Empty>;
  ReplaceAssignmentConversation(
    request: AssignmentV2_ReplaceAssignmentConversationRequest,
  ): Promise<AssignmentV2_ReplaceAssignmentConversationResponse>;
  ReassignConversations(request: AssignmentV2_ReassignConversationsRequest): Promise<Empty>;
  ReassignConversation(request: AssignmentV2_ReassignConversationRequest): Promise<Empty>;
  SearchAssignmentReviewers(request: AssignmentV2_SearchAssignmentUserRequest): Promise<AssignmentV2_UserAvatars>;
  SearchAssignmentReviewees(request: AssignmentV2_SearchAssignmentUserRequest): Promise<AssignmentV2_UserAvatars>;
  LinkReview(request: AssignmentV2_LinkReviewRequest): Promise<Empty>;
  GetLookerDashboardAssignmentFilterValue(request: Empty): Promise<LookerFilterValue>;
}

export interface AssignmentsReviewService {
  ValidateAssignmentReview(request: AssignmentReview_ValidateAssignmentReviewRequest): Promise<Empty>;
  CreateAssignmentReview(
    request: AssignmentReview_CreateAssignmentReviewRequest,
  ): Promise<AssignmentReview_GetAssignmentReviewsResponse_Review>;
  GetAssignmentReviews(
    request: AssignmentReview_GetAssignmentReviewsRequest,
  ): Promise<AssignmentReview_GetAssignmentReviewsResponse>;
}

export interface AssignmentsBackOfficeService {
  BackOfficeGetAssignments(request: AssignmentV2_GetAssignmentsRequest): Promise<AssignmentV2_GetAssignmentsResponse>;
}
